import React from 'react';
import { Grid } from 'react-flexbox-grid';
import PropTypes from 'prop-types';

import CommonHeader from 'routes/Documents/components/CommonHeader';
import BottomFormControls from 'routes/Documents/components/BottomFormControls';

import HistoryContainer from 'containers/HistoryContainer';
import Paper from 'components/Paper';

import Form from './Form';
import { getLatestUnfinishedCommit } from 'lib/documentHandling';
import EditableV2 from 'routes/Documents/containers/EditableV2';

import historyMapper, { sorter } from './historyMapper';

import { injectIntl, intlShape } from 'react-intl';

const Lifestyle = ({ names, documents, editingDocument, onStartEdit, onCreate, intl }) => {
  return (
    <div>
      <Paper topMargin={false}>
        <Grid fluid>
          <CommonHeader
            names={names}
            localeId="lifestyle.title"
            infoText="lifestyle.infoText"
            addNewText="lifestyle.addNew"
            mode="create"
            editing={editingDocument}
            startEdit={onCreate}
          />
        </Grid>
        {editingDocument && (
          <EditableV2
            documentId={editingDocument.documentId}
            moduleName={names[0]}
            editedCommit={getLatestUnfinishedCommit(editingDocument)}
          >
            <Form />
          </EditableV2>
        )}
        {!editingDocument && (
          <HistoryContainer
            documents={documents}
            emptyText="lifestyle.emptyText"
            sorter={sorter}
            mapper={historyMapper(names[0], onStartEdit)}
          />
        )}
      </Paper>
      {editingDocument && (
        <BottomFormControls
          name={names[0]}
          editId={editingDocument.documentId}
          commitId={getLatestUnfinishedCommit(editingDocument).commitId}
        />
      )}
    </div>
  );
};

Lifestyle.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  onStartEdit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  intl: intlShape,
};

export default injectIntl(Lifestyle);
